module.exports = ".width-10{\r\n    width: 10%\r\n}\r\n.width-20{\r\n    width: 20%\r\n}\r\n.width-30{\r\n    width: 30%\r\n}"